/*
 * One place for the cache keys so invalidations cannot drift from the queries
 * they are meant to clear.
 */
export const queryKeys = {
  user: ['user'] as const,
  settings: ['settings'] as const,
  providers: ['providers'] as const,
  movies: (lang: string) => ['movies', lang] as const,
  tvshows: (lang: string) => ['tvshows', lang] as const,
  downloaded: (lang: string) => ['downloaded', lang] as const,
  myhistory: (lang: string) => ['myhistory', lang] as const,
  readings: ['readings'] as const,
  koboDevices: ['koboDevices'] as const,
  availableBooks: ['availableBooks'] as const
}
